import ApplicationLayout from '@rio-cloud/rio-uikit/ApplicationLayout';
import { FormattedMessage } from 'react-intl';
import { useSearchParams } from 'react-router';

import { getCheckoutUrl } from './checkoutService';
import { sendIFrameCloseMessageToParent } from './common/iframeUtils';

function RecommendationsBody() {
    return (
        <ApplicationLayout className='flex-1-1 overflow-y-auto'>
            <div className='padding-20'>
                <div className='alert alert-success margin-bottom-25 padding-25'>
                    <h4 className='margin-top-0'>
                        <FormattedMessage id={'intl-msg:recommendations.vehiclesAdded.headline'} />
                    </h4>
                    <p className='text-wrap-balance'>
                        <FormattedMessage
                            id={'intl-msg:recommendations.vehiclesAdded.text'}
                            values={{ bold: (chunks: React.ReactNode) => <strong>{chunks}</strong> }}
                        />
                    </p>
                </div>
                <div className='panel panel-default padding-25 margin-bottom-0'>
                    <div className='display-flex-sm gap-25'>
                        <div className='flex-1-1-0'>
                            <h4>
                                <FormattedMessage id={'intl-msg:recommendations.geo.headline'} />
                            </h4>
                            <p>
                                <FormattedMessage
                                    id={'intl-msg:recommendations.geo.description'}
                                    values={{
                                        link: (chunks: React.ReactNode) => (
                                            <strong>
                                                <a
                                                    href='https://rio.cloud/en/marketplace/produkt/geo'
                                                    target='_blank'
                                                    rel='noreferrer'
                                                >
                                                    {chunks}
                                                </a>
                                            </strong>
                                        ),
                                        bold: (chunks: React.ReactNode) => <strong>{chunks}</strong>,
                                    }}
                                />
                            </p>
                        </div>
                        <div className='width-300 width-200-md margin-x-auto padding-top-25'>
                            <img
                                className='img-responsive'
                                alt='geo'
                                src='https://rio.cloud/fileadmin/Marketplace/RIO/Products/Geo/General/geo_routeplanning_desktop_right.png'
                            />
                        </div>
                    </div>
                </div>
            </div>
        </ApplicationLayout>
    );
}

const RecommendationsFooter = ({ targetUrl }: { targetUrl: string }) => (
    <div className='display-flex justify-content-end padding-20 bg-white border border-top-only border-color-light rounded-bottom hidden-empty'>
        <button className='btn btn-default' type='button' onClick={sendIFrameCloseMessageToParent}>
            <FormattedMessage id={'intl-msg:recommendations.close'} />
        </button>
        <a href={targetUrl}>
            <button className='btn btn-primary margin-left-20' type='button'>
                <span className='uikit-icon icon-shopping-cart' />
                <FormattedMessage id={'intl-msg:recommendations.geo.continue'} />
            </button>
        </a>
    </div>
);

const Recommendations = () => {
    const [searchParams] = useSearchParams();
    const deviceType = searchParams.get('deviceType');
    const resourceIds = searchParams.get('resourceIds')?.split(',') || [];
    const targetUrl = getCheckoutUrl(deviceType, resourceIds);

    return (
        <div id='recommendations' className='display-flex flex-column height-100vh'>
            <RecommendationsBody />
            <RecommendationsFooter targetUrl={targetUrl} />
        </div>
    );
};

export default Recommendations;
